import { createContext, useContext, useReducer } from "react";
import { initialState, productOptionReducer } from "../reducer/productOptionReducer";

const ProductOptionStateContext = createContext();
const ProductOptionDispatchContext = createContext();

export const ProductOptionProvider = ({ children }) => {
  const [state, dispatch] = useReducer(productOptionReducer, initialState);

  return (
    <ProductOptionStateContext.Provider value={state}>
      <ProductOptionDispatchContext.Provider value={dispatch}>
        {children}
      </ProductOptionDispatchContext.Provider>
    </ProductOptionStateContext.Provider>
  )
}

export const useProductOptionState = () => {
  const context = useContext(ProductOptionStateContext);

  if (!context) throw Error('useProductOptionState는 ProductOptionProvider 내에서 사용해야 합니다.');
  return context;
}

export const useProductOptionDispatch = () => {
  const context = useContext(ProductOptionDispatchContext);

  if (!context) throw Error('useProductOptionDispatch는 ProductOptionProvider 내에서 사용해야 합니다.');
  return context;
}